import { useLayoutEffect } from 'react';

export const useLockBodyScroll = (shouldLock) => {
  useLayoutEffect(() => {
    const preventScroll = (e) => {
      const modalContent = document.querySelector('.modal-content-scrollable');
      if (modalContent && modalContent.contains(e.target)) {
        // Allow scroll inside the modal content
        return;
      }
      e.preventDefault();
    };

    if (shouldLock) {
      const scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      document.body.style.touchAction = 'none';

      // Attach touchmove listener for background
      document.addEventListener('touchmove', preventScroll, { passive: false });
    } else {
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      document.body.style.touchAction = '';

      window.scrollTo(0, parseInt(scrollY || '0') * -1);

      document.removeEventListener('touchmove', preventScroll);
    }

    return () => {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
      document.removeEventListener('touchmove', preventScroll);
    };
  }, [shouldLock]);
};
